import actions from './moduleQueryActions';
import mutations from './moduleQueryMutations';
import getters from './moduleQueryGetters';
import state from './moduleQueryState';

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
